import map from 'lodash/map';
import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import {connect} from 'react-redux';
import {getClubs} from '../../../../actions/app/mpt/clubs';
import {editWeek} from '../../../../actions/app/mpt/weeks';
import Card from '../Card';
import CreateCard from '../createCard';
import './Week.css';

class Week extends React.Component {
  state = {
    startDate: null,
    endDate: null,
    modifying: false,
    textWindow: null,
    colorText: null,
    colorBackground: null,
    playerName: null,
    collapse: false,
  };

  componentWillMount() {
    const {data, dispatch} = this.props;
    this.setState({
      startDate: moment(data.start),
      endDate: moment(data.end),
      textWindow: data.display.textWindow,
      colorText: data.display.colorTextWindow,
      colorBackground: data.display.colorBackgroundWindow,
    });
    dispatch(getClubs());
  }

  changeDate(weekId) {
    const {
      startDate,
      endDate,
      modifying,
      textWindow,
      colorText,
      colorBackground,
    } = this.state;
    const {dispatch} = this.props;
    this.setState({modifying: false});
    modifying &&
      dispatch(
        editWeek(
          {
            start: startDate.format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
            end: endDate.format('YYYY-MM-DDTHH:mm:ss.SSSSZ'),
            display: {
              textWindow,
              colorTextWindow: colorText,
              colorBackgroundWindow: colorBackground,
            },
          },
          weekId,
        ),
      );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        modifying: false,
      });
    }
  }

  render() {
    const {data, clubs} = this.props;
    const {
      modifying,
      startDate,
      endDate,
      textWindow,
      colorText,
      colorBackground,
      collapse,
    } = this.state;
    return (
      <div className="week container">
        <h1
          data-toggle="collapse"
          data-target={`#collapse${data.id}`}
          onClick={() =>
            collapse
              ? this.setState({collapse: false})
              : this.setState({collapse: true})
          }>
          Week {data.id}{' '}
          {!collapse ? (
            <i className="fa fa-chevron-circle-right" />
          ) : (
            <i className="fa fa-chevron-circle-down" />
          )}
        </h1>
        <section id={`collapse${data.id}`} className="collapse">
          {startDate && clubs.list && (
            <div>
              <div className="row">
                <div className="col-md-3 text-center">
                  <p>START</p>
                  <DatePicker
                    selected={startDate}
                    onChange={date =>
                      this.setState({startDate: date, modifying: true})
                    }
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="d/M/yyyy hh:mm aa"
                    timeCaption="time"
                  />
                </div>
                <div className="col-md-3 text-center">
                  <p>END</p>
                  <DatePicker
                    selected={endDate}
                    onChange={date =>
                      this.setState({endDate: date, modifying: true})
                    }
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="d/M/yyyy hh:mm aa"
                    timeCaption="time"
                  />
                </div>
              </div>
              <div className="row">
                <div className="text-center col-md-3">
                  <p className="text-center">Text</p>
                  <textarea
                    className="textInput"
                    value={textWindow}
                    onChange={text =>
                      this.setState({
                        textWindow: text.target.value,
                        modifying: true,
                      })
                    }
                    alt=""
                  />
                </div>
                <div className="text-center col-md-3">
                  <p className="text-center">Color text</p>
                  <div className="colorTextContainer">
                    <select
                      onChange={color =>
                        this.setState({
                          colorText: color.target.value,
                          modifying: true,
                        })
                      }
                      className="form-control"
                      value={colorText}>
                      <option>#4a4a4a</option>
                      <option>#71C94C</option>
                      <option>#E43D32</option>
                      <option>#CECECE</option>
                      <option>#E93F33</option>
                      <option>#72BA4C</option>
                      <option>#874DC4</option>
                      <option>#76CC4C</option>
                      <option>#FFFFFF</option>
                      <option>#000000</option>
                    </select>
                    <div
                      style={{
                        width: 32,
                        height: 32,
                        backgroundColor: colorText,
                        marginLeft: 20,
                      }}
                    />
                  </div>
                </div>
                <div className="text-center col-md-3">
                  <p className="text-center">Color background</p>
                  <div className="colorTextContainer">
                    <select
                      onChange={color =>
                        this.setState({
                          colorBackground: color.target.value,
                          modifying: true,
                        })
                      }
                      className="form-control"
                      value={colorBackground}>
                      <option>#f7f7f7</option>
                      <option>#71C94C</option>
                      <option>#E43D32</option>
                      <option>#CECECE</option>
                      <option>#E93F33</option>
                      <option>#72BA4C</option>
                      <option>#874DC4</option>
                      <option>#76CC4C</option>
                      <option>#FFFFFF</option>
                      <option>#000000</option>
                    </select>
                    <div
                      style={{
                        width: 32,
                        height: 32,
                        backgroundColor: colorBackground,
                        marginLeft: 20,
                      }}
                    />
                  </div>
                </div>
                <div
                  className="col-md-3 text-center"
                  style={{
                    height: 100,
                    width: '10%',
                    backgroundColor: colorBackground,
                    color: colorText,
                  }}>
                  {textWindow}
                </div>
                <div className="col-md-1">
                  <button
                    className={modifying ? 'btn-warning' : 'btn-success'}
                    onClick={() => this.changeDate(data.id)}>
                    Modify
                  </button>
                </div>
              </div>
              <div className="">
                <div>
                  <h3>Add card</h3>
                  <CreateCard data={data} />
                </div>
                <div className="row cardContainer">
                  {map(data.cards, card => {
                    return (
                      <Card
                        key={card.id}
                        card={card}
                        week={data}
                        clubs={clubs.list}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    );
  }
}
export default connect(
  state => ({
    // weeks: state.app.mpt.weeks.list,
    clubs: state.app.mpt.clubs,
  }),
  dispatch => ({dispatch}),
)(Week);



// WEBPACK FOOTER //
// ./src/pages/MPT/Creation/Week/index.js